const Disclaimer = () => {
  return (
    <div
      style={{
        textAlign: 'justify',
        textJustify: 'inter-word',
        fontSize: '12px',
        lineHeight: '1.3',
      }}
    >
      <p style={{ color: 'black' }}>
        <strong>How TSP surfaces information</strong>
      </p>
      <p>
        TSP aggregates and organizes information from publicly available sources using structured,
        exploration-oriented methods to help you orient and organize your work.
        <ul>
          <li>
            <strong>Scholarly materials</strong> (e.g., publications and patents) are surfaced from
            widely used public indexes and databases
          </li>
          <li>
            <strong>People</strong> are surfaced as contextual signals based on authorship,
            affiliation, and publicly available metadata
          </li>
          <li>
            <strong>Funding opportunities, events, organizations, and jobs</strong> are surfaced as
            exploratory starting points using curated third-party sources assisted by AI methods.
          </li>
        </ul>
      </p>
      <p>
        TSP does not claim completeness or authority. All surfaced information is intended to
        support exploration and sensemaking and should be reviewed against original sources as part
        of your research workflow; you retain editorial control.
      </p>
    </div>
  );
};
export default Disclaimer;
